import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { NHeaderTestIds } from '@webcommon/types';

export const useStatusPageHandlers = () => {
  const navigate = useNavigate();

  const handleGoToMain = useCallback(() => navigate('/', { replace: true }), [navigate]);

  const handleRequestSupport = useCallback(() => {
    const header = document.querySelector(`[data-testid="${NHeaderTestIds.HEADER}"]`);
    const buttons = header?.querySelectorAll('button') || [];
    const helpButton = [...buttons].filter(b => b.innerText === 'Помощь');

    if (helpButton.length > 0) {
      const button = helpButton[0];
      button.click();
    }
  }, []);

  const handleRefreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    handleGoToMain,
    handleRequestSupport,
    handleRefreshPage,
  };
};
